import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createBooking = (data) => axios.post(`${API}/bookings`, data).then((r) => r.data);
export const createContact = (data) => axios.post(`${API}/contacts`, data).then((r) => r.data);
